import { RunException } from "./exception";
import type { Result, ResultError } from "./result";

function unwrap<T, E extends ResultError>(result: Result<T, E>) {
	if (!result.success) {
		throw new RunException(result.error.message, {
			cause: result.error.cause,
			data: result.error.data,
		});
	}

	return result.data;
}

function unwrapOr<T, E extends ResultError>(
	result: Result<T, E>,
	defaultValue: T,
) {
	if (!result.success) {
		return defaultValue;
	}

	return result.data;
}

function unwrapOrElse<T, E extends ResultError, S = unknown>(
	result: Result<T, E>,
	fn: (error: E) => S,
) {
	if (!result.success) {
		return fn(result.error);
	}

	return result.data;
}

export { unwrap, unwrapOr, unwrapOrElse };
